<template lang="pug">
    article#egressos
        //- Banner
        Menu(:menu="menu")
        Conteudo(:conteudo="pagina.secoes[0].conteudo", v-if="pagina.secoes")
</template>

<script>
import pagina from '@/mixins/pagina'
// import Banner from '@components/BannerEgressos/BannerEgressos'
import Menu from '@components/MenuEgressos/MenuEgressos'
import Conteudo from '@components/ConteudoEgressos/ConteudoEgressos'

export default {
    name: "view-egressos",
    components:{
        // Banner,
        Menu,
        Conteudo
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./Egressos.styl"></style>